import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../../types/routes.types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/risk-score/audit/$id/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RISK_SCORE });
    context.validatePermissions({ isAllowed, preload });
  },
});
